module.exports = __webpack_public_path__ + "img/hero-reports-2.94fbced0.jpg";